import { IR_RESCHEDULE, RESCHEDULE_SERVICE_REQUEST, generateBFFUrl } from '@/configs/apiEndPoints';
import axiosInstance from './axiosConfig';
import { serviceRequestType } from '@/context/serviceRequestContext';
import { ServiceSlot } from '@/components/ChooseSlot';
import { ACCOUNT_ID_QUERY_PARAM } from '@/configs/serviceConstants';

interface RequestSummaryType {
  serviceType: serviceRequestType;
  serviceDate: Date;
  serviceSlot?: ServiceSlot;
  serviceReqID: string;
}

interface SelectedProductType {
  accountId: string;
  hubCode: string;
  componentId: string;
  id: string;
}

const getServiceType = (serviceType: serviceRequestType) => {
  switch (serviceType?.toLowerCase()) {
    case 're_install':
      return 'RE_INSTALL';
    case 'repair':
      return 'REPAIR';
    case 'uninstall':
      return 'UNINSTALL';
    case 'ms':
      return 'MS';
    case 'cr':
      return '';
  }
};

export const rescheduleServiceRequest = async (
  selectedProduct: SelectedProductType,
  requestSummary: RequestSummaryType,
  rescheduleReasonCode?: any,
  rescheduleDescription?: any,
) => {
  try {
    const { componentId, accountId, hubCode, id } = selectedProduct;
    const { serviceDate, serviceSlot, serviceType, serviceReqID } = requestSummary;
    const rescheduleData = await axiosInstance.post(
      generateBFFUrl(`${RESCHEDULE_SERVICE_REQUEST}?${ACCOUNT_ID_QUERY_PARAM}=${accountId}`),
      {
        service_request_number: serviceReqID,
        account_id: accountId,
        asset_code: componentId,
        job_type: getServiceType(serviceType),
        slot_date: serviceDate,
        selected_slot: serviceSlot,
        hub_code: hubCode,
        asset_id: id,
        reason_code: rescheduleReasonCode,
        reason_comments: rescheduleDescription,
      },
    );
    return rescheduleData.data;
  } catch (error) {
    throw error;
  }
};

export const rescheduleInstallationRequest = async (reqBody: any) => {
  try {
    const IRrescheduleData = await axiosInstance.patch(generateBFFUrl(IR_RESCHEDULE), reqBody);
    return IRrescheduleData.status;
  } catch (error) {
    throw error;
  }
};
